import { ChangeDetectionStrategy, Component, computed } from '@angular/core'

import { CardProject } from 'app/core/cms/generated/api-types'
import { ProjectItemCardComponent } from 'app/shared/project-item-card/project-item-card.component'

import { CmsBlock } from '../../cms-block'

@Component({
  selector: 'pai-card-project',
  templateUrl: './card-project.component.html',
  styleUrls: ['./card-project.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ProjectItemCardComponent],
  providers: [{ provide: CmsBlock, useExisting: CardProjectComponent }],
})
export class CardProjectComponent extends CmsBlock<CardProject> {
  readonly __typename = 'CardProject'
  protected readonly project = computed(() => this.data().item)
}
